import { ECG_CONSTANTS } from '../utils/ecg-constants';
import {
    ArrangementType,
    CaliperMode,
    Cultures,
    Format,
    GuidedComparisonType,
    PaperRate,
    TimeAlignment,
} from '../models/enums';
import { ICaliperMessage, ICaliperViewModel, ITraceViewModel } from '../models/interfaces';
import {
    IChartState,
    ICustomCommandState,
    IEcgState,
    IMultiViewerState,
    ISummaryState,
    IToolbarState,
    IViewerState,
} from '../../store/ecg-viewer-state.models';

export class MultiViewerState implements IMultiViewerState {
    studySpacing = ECG_CONSTANTS.STUDIES_SPACING;
    horizontalStudySpacing = ECG_CONSTANTS.HORIZONTAL_STUDIES_SPACING;
}

export class ViewerState implements IViewerState {
    toolbarVisible: boolean = true;
}

export class CustomCommandState implements ICustomCommandState {
    visible: boolean = false;
    text: string = '';
    source: string = '';
}

export class ToolbarState implements IToolbarState {
    customCommandState = new CustomCommandState();
}

export class ChartState implements IChartState {
    arrangement: ArrangementType = ArrangementType.SixXTwo; //12x1 6x2 ....
    timeAlignment: TimeAlignment = TimeAlignment.Sequential;
    paperRate: PaperRate = PaperRate.mm25;
    format = Format.standard;
    fiducialPointsVisible = false;
    paperOpacity = 0.2;
    isFitBaseline = false;
    traceSpacing = ECG_CONSTANTS.TRACE_SPACING;
    guidedComparison: GuidedComparisonType = GuidedComparisonType.TraceToTrace; //tipo di confronto traccia traccia , sovrapposto , esame su esame...
    caliperMode = CaliperMode.single;
    zoomFactor: number = 1;
    printAsDisplayed = false;
}

export class SummaryState implements ISummaryState {
    visible = true;
}

export class DetailsState implements ISummaryState {
    visible = true;
    summaryState = new SummaryState();
}

export class EcgState implements IEcgState {
    visualComparison = false;
    culture = Cultures.en_US;
    multiViewerState = new MultiViewerState();
    viewerState = new ViewerState();
    chartState = new ChartState();
    detailsState = new DetailsState();
    toolbarState = new ToolbarState();
}

export class CaliperMessage implements ICaliperMessage {
    constructor(trace: ITraceViewModel, caliper: ICaliperViewModel) {
        this._trace = trace;
        this._caliper = caliper;
    }

    private _trace: ITraceViewModel;

    get trace() {
        return this._trace;
    }

    private _caliper: ICaliperViewModel;

    get caliper() {
        return this._caliper;
    }
}
